define('adminPhrasesListRowToolsView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'bootbox',
  'settings',
  'tableFieldView',
  'template!adminPhrasesListRowToolsView',
  'entities/phrases'
], function (
  App,
  Module,
  _,
  $,
  Bootbox,
  Settings,
  FieldView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-phrases-list-row-tools-view table-field-view',

    ui: {
      deleteButton: '.delete'
    },

    events: {
      'click @ui.deleteButton': 'onDelete'
    },

    onDelete: function (e) {
      e.stopPropagation();
      e.preventDefault();

      Bootbox.confirm(_.i18n('common.confirmDelete'), _.bind(function (result) {
        if (result) {
          var secId = this.model.id || this.model.get('secId');
          if (!secId) return;
          $.ajax({
            type: 'DELETE',
            url: Settings.url('compuzz2', 'v2/phrases/' + secId),
            success: _.bind(function () {
              this.tableView.bodyView.deleteRow(this.rowView);
            }, this)
          });
        }
      }, this));
    }
  });
});

